import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import MergeGamesModal from "./merge-games-modal.vue";
import Turbolinks from "turbolinks";

interface Props {
  game: { id: number; name: string };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'merge-games-button',
  props: {
    game: {}
  },
  setup(__props: any) {

const props = __props;

const isModalActive = ref(false);

function activateModal() {
  document.documentElement.classList.add("is-clipped");
  isModalActive.value = true;
}

function deactivateModal() {
  document.documentElement.classList.remove("is-clipped");
  isModalActive.value = false;
}

function onSubmit() {
  Turbolinks.visit(window.location.href);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      onClick: activateModal,
      class: "dropdown-item has-text-danger js-merge-games-button"
    }, " Merge "),
    (isModalActive.value)
      ? (_openBlock(), _createBlock(MergeGamesModal, {
          key: 0,
          isActive: isModalActive.value,
          game: __props.game,
          onClose: deactivateModal,
          onSave: onSubmit
        }, null, 8, ["isActive", "game"]))
      : _createCommentVNode("", true)
  ]))
}
}

})